







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import WorkHttp from '@/http/WorkHttp';
import Dialog from '@/components/Dialog.vue';
import { Product } from '@/store/types/work/invoice';

@Component({
  components: { Dialog }
})
export default class ChangeProduct extends Vue {
  @Prop() showDialog!: boolean;
  @Prop() outgoing!: boolean;
  @Prop() value!: Product;
  @Watch('value', { immediate: true, deep: true })
  onValueChanged (newVal: any) {
    this.formData = {
      wholesale_price: newVal.wholesale_price,
      price: newVal.price,
      percent_markup: newVal.percent_markup,
      equilaze_price: newVal.equilaze_price
    };
  }
  public loading = false;
  valid = false;
  formData = {
    wholesale_price: 0,
    price: 0,
    percent_markup: null,
    equilaze_price: null
  }

  get computedProduct () {
    return {
      title: this.outgoing ? this.value.from_product_title : '',
      enterprise_id: this.outgoing ? this.value.from_enterprise_id : this.value.enterprise_id,
      id: this.outgoing ? this.value.from_product_id : this.value.product_id
    };
  }

  public change () {
    this.loading = true;
    (new WorkHttp(this.computedProduct.enterprise_id || 0)).post({
      url: `/invoices/${this.outgoing ? 'outgoing' : 'income'}/${this.value.invoice_id}/products/${this.computedProduct.id}`,
      data: this.formData
    })
      .then(_ => {
        this.$emit('save');
      }).catch(e => {
        alert('Сталась помилка під час запиту.');
      }).then(_ => {
        this.loading = false;
      });
  }
}
